import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Button from '..';

import './index.css';

class GreenButton extends Component {
  constructor(props) {
    super(props);

    this.getClassNames = this.getClassNames.bind(this);
  }

  getClassNames() {
    const { className } = this.props;
    return classnames({
      Green: true,
      [className]: true,
    });
  }

  render() {
    const { getClassNames } = this;
    return <Button {...this.props} className={getClassNames()} />;
  }
}

GreenButton.propTypes = {
  className: PropTypes.string,
};

GreenButton.defaultProps = {
  className: '',
};

export default GreenButton;
